import { request } from "../"
export function getSuppliers(params = {}) {
    return request({ url: "suppliers/", params })
}
export function createSupplier(data = {}) {
    return request({ url: "suppliers/", method: "POST", data })
}
export function getSupplier(id) {
    return request({ url: `suppliers/${id}/` })
}
export function updateSupplier(id, data) {
    return request({ url: `suppliers/${id}/`, method: "PUT", data });
}
export function ToogleActivationSupplier(id){
    return request({ url: `suppliers/${id}/activate/`, method: "PUT"});
}


// WEBPACK FOOTER //
// ./src/api/suppliers/index.js